import stateClass, {CHANGE_EVENT} from '../baseState';
import {SchoolTypesState, GROUP_CHANGE_EVENT as T_GROUP_CHANGE_EVENT, DISABLE_EVENT as ST_DISABLE_EVENT} from '../schoolTypes/state';
import {classesState, GROUP_CHANGE_EVENT as C_GROUP_CHANGE_EVENT} from './classesState';
//import {layerState, CHANGE_EVENT as LS_CHANGE_EVENT} from './layer';
//import {indicatorsState} from './schools/indicators';

const SHOW_FILTERS_CHANGE_EVENT = 'show_filters_change_event';
const SET_MUNICIPALITY_EVENT = 'filters_set_municipality_event';

class filterStateClass extends stateClass {

    constructor(props) {
        
        super(props);

        SchoolTypesState.on(T_GROUP_CHANGE_EVENT, this.setSchoolTypesFilter.bind(this, SchoolTypesState));
        classesState.on(C_GROUP_CHANGE_EVENT, this.setClassesFilter.bind(this, classesState));
        
        this.typesFilterData = {field: SchoolTypesState.filterField, values: SchoolTypesState.activeGroups};
        this.classesFilterData = classesState.activeClasses;
        this.municipalities = [];
        this.activeFiltersSelectors = {
            types: true,
            language: true,
            classes: true,
            municipality: true,
            years: true
        };

        var filterLayerMap = {
            school_types: ['types', 'language', 'classes', 'municipality', 'years'],
            quality_indicators: ['types', 'language', 'municipality', 'years'],
            students: ['types', 'municipality'],
            people: [],
            infrastruture: []
        }

        

    /*    layerState.on(LS_CHANGE_EVENT, () => {

            if(layerState.prevData.indexOf('school_types') > -1 && layerState.data.indexOf('school_types') === -1) {

                this.classesFilterData = classesState.getGroupByID('all').classes;
            }



            for(var key in this.activeFiltersSelectors) {

                this.activeFiltersSelectors[key] = false;
            }

            var layers = layerState.getActiveLayers();

            console.log('layer state ls change event', layers);

            for (var i = layers.length - 1; i >= 0; i--) {

                var filters = filterLayerMap[layers[i]];

                if(typeof filters === 'undefined') {
                    continue;
                }

                for (var n = filters.length - 1; n >= 0; n--) {

                    if(filters[n] == 'years' && indicatorsState.getChartKey() === "otrgad_gr") {
                        continue;
                    }

                    this.activeFiltersSelectors[filters[n]] = true;
                }
                
            }

        //  classesState.setActiveGroupByID('all');

            this.emit(SHOW_FILTERS_CHANGE_EVENT);
        });*/
    }

    getActiveFilters() {

        return this.activeFiltersSelectors;
    }

    setSchoolTypesFilter(STState) {

        this.typesFilterData = {field: STState.filterField, values: STState.activeGroups};

        this.emit(CHANGE_EVENT);
    }

    setClassesFilter(CState) {

        this.classesFilterData = CState.activeClasses;

        this.emit(CHANGE_EVENT);
    }

    getClassesFilterData() {

        return this.classesFilterData;
    }

    setMunicipality(municipalities) {

        this.municipalities = municipalities;

        this.emit(CHANGE_EVENT);
        this.emit(SET_MUNICIPALITY_EVENT);
    }

    clearMunicipalities() {

        this.municipalities = [];

        this.emit(CHANGE_EVENT);
        this.emit(SET_MUNICIPALITY_EVENT);
    }

    getMunicipalities() {

        return this.municipalities;
    }

    removeMunicipalities(municipalities) {

        for (var i = municipalities.length - 1; i >= 0; i--) {

            var index = this.municipalities.indexOf(municipalities[i]);

            if(index > -1) {
                this.municipalities.splice(index, 1);
            }
        }

        this.emit(CHANGE_EVENT);
        this.emit(SET_MUNICIPALITY_EVENT);
    }

    filterByProps(props) {

        var pass = false;

        if(this.typesFilterData) {

            if(this.typesFilterData.values.indexOf(props[this.typesFilterData.field]) > - 1){
                pass = true;
            }
        }
        
        if(this.classesFilterData && pass) {

            var pass = false;
            for (var i = this.classesFilterData.length - 1; i >= 0; i--) {

                var group = this.classesFilterData[i] + 'kl';
            //  console.log('props[group]', group, props[group]);
                if(props[group] > 0){
                    pass = true;
                }
            }

            if(props.Tips == 6 && this.classesFilterData.length === 12) {

                pass = true;
            }

        /*    if(layerState.isActive('quality_indicators')) {
                pass = true;
            }
*/
        }

        if(this.municipalities.length > 0 && pass){

            if(this.municipalities.indexOf(props.Pasvaldiba) > -1){

                pass = true;
            } else {
                pass = false;
            }
        }

        return pass;
    }
}

var FilterState = new filterStateClass();


export {FilterState, CHANGE_EVENT, SHOW_FILTERS_CHANGE_EVENT, SET_MUNICIPALITY_EVENT};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/filters/state.js